<template>
    <div id="file-upload">
        <button id="featured-button" class="btn btn-small btn-block" v-if="files.length === 0" @click.prevent="openModal('squirrel-file-upload')">
            {{ label }}
        </button>

        <div class="images">
            <div class="image" v-for="(file, index) in files"  v-if="file">
                <img :src="file.urls ? file.urls.regular : file.url" v-if="file">
                <button class="image__remove" type="button"
                    @click.prevent="removeFile(index)">
                    <i class="icon ion-md-close"></i>
                </button>
            </div>
        </div>
        <media-library
            name="featured-image-media-library"
            :opened="modalOpened"
            @closedModal="onClosedModal"
            :group="group"
            v-model="files" />
    </div>
</template>

<script>
    //import MediaLibrary from './media-library.vue';
    // const Uppy = require('@uppy/core');
    // const XHRUpload = require('@uppy/xhr-upload');
    // const Dashboard = require('@uppy/dashboard');
    //const Url = require('@uppy/url');
    // const MediaLibrary = require('../../lib/MediaLibrary');

    export default {
        props: {
            label: {
                type: String,
                default: 'Set featured image',
            },
            name: {
                type: String,
                required: true,
            },
            value: {
                default: null,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            type: {
                type: String,
                default: 'image'
            },
            endpoint: {
                type: String,
                default: '/api/media/handle'
            },
            group:{
                type: Object
            }
        },
        data() {
            return {
                gallery: [],
                files: [],
                // uppyFileUpload: null,
                // uppyOptions: {
                //     autoProceed: false,
                //     providers: [ 'url' ],
                //     allowMultipleUploads: false,
                //     restrictions: {
                //         maxFileSize: 100000000,
                //         maxNumberOfFiles: 1,
                //         minNumberOfFiles: 1
                //     }
                // },
                modalOpened: false
            }
        },
        mounted() {
            // MicroModal.init({
            //     disableScroll: true
            // });
            // let token = document.head.querySelector('meta[name="csrf-token"]');

            // if( token ){
            //     this.uppyFileUpload = Uppy(this.uppyOptions)
            //     .use(Dashboard)
            //     .use(MediaLibrary, {
            //         target: Dashboard,
            //         companionUrl: '/api'
            //     })
            //     .use(XHRUpload, {
            //         formData: true,
            //         endpoint: this.endpoint,
            //         headers: {
            //             'X-Requested-With' : 'XMLHttpRequest',
            //             'X-CSRF-TOKEN': token.content
            //         }
            //     });

            //     this.uppyFileUpload.on('file-added', (file) => {
            //         this.uppyFileUpload.setFileMeta(file.id, {
            //             type: this.type,
            //             group: this.group.id
            //         });
            //     });

            //     this.uppyFileUpload.on('complete', (result) => {
            //         this.files = result.successful[0].response.body.files;
            //         this.uppyFileUpload.getPlugin('Dashboard').closeModal();
            //     });

            //     this.uppyFileUpload.on('selected', (result) => {
            //         this.files.push(result);
            //         this.uppyFileUpload.getPlugin('Dashboard').closeModal();
            //     });
            // }
        },
        methods: {
            updateFromValue() {
                if(this.value !== null){
                    this.files = [{
                        url : this.value
                    }];
                }
            },
            removeFile(index) {
                this.files.splice(index, 1);
            },
            openModal(modal){
                this.modalOpened = true;
            },
            onClosedModal(){
                this.modalOpened = false;
            }

        },
        watch: {
            files(files) {
                if(typeof files[0] !== 'undefined'){
                    this.$emit('input', files[0].urls ? files[0].urls.regular || null : files[0].url || null);
                }
            },
            value() {
                if(!this.files.length) {
                    this.updateFromValue();
                }
            }
        }
    }
</script>

<style lang="scss">

</style>
